module.exports = [{
      plugin: require('../../../plugins/gatsby-powergo-brp-smartsite-theme/gatsby-browser.js'),
      options: {"plugins":[],"instockToken":"ee4f98f880b5fc332ed3192eef81d4e6f20c32ca","sourceEnv":"production","websiteDomain":"www.raxfin.ca"},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
